<template>
  <des-icon icon="fa-light fa-circle-notch" spin class="text-3xl text-blue-50 absolute top-1/2 left-1/2 -mt-8 -ml-8" />
</template>
